import ModalFiltro from "../../../../../components/modalFiltros";
import { Button, Grid } from "@mui/material";
import { SelectSede } from "../../../../../components/selects/sede";
import { SelectMinisterio } from "../../../../../components/selects/ministerio";
import { UseList } from "../../context/getListaPg";

export const ButtonFiltroPgInfo = () => {

  const { handleFilter, alterCampos, pgs, reset, dados } = UseList();

  const getSede = (value: string) => alterCampos('sede', value);

  const getMinisterio = (value) => alterCampos('ministerio', value?.target?.value);

  return (<>
    <ModalFiltro>
      <>
        <Grid>
          <SelectSede action={getSede} value={dados?.sede} />
          <SelectMinisterio action={getMinisterio} idsede={dados?.sede} valor={dados?.ministerio} />
        </Grid>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            marginTop: '8px'
          }}
        >
          <Button color="error" onClick={reset}>Cancelar</Button>
          <Button
            variant="contained"
            sx={{ boxShadow: 'none' }}
            onClick={handleFilter}
          >
            Filtrar
          </Button>
        </div>
      </>
    </ModalFiltro>
  </>);
};
